import type { BidTypeName, ElplanPartition, PlanValues } from 'api/elplan/elplan.types'
import type { ReactElement } from 'react'

export type FormattedBid = {
  fake?: boolean
  type: BidTypeName
  tag?: number | null
  date?: ISODateTime | string
  startTime: ISODateTime | string
  endTime: ISODateTime | string
  displayStartTime?: string
  displayEndTime?: string
  volume?: number | number[]
  price?: number
  block_order?: number
  editable?: boolean
  clear?: boolean
  planValues?: PlanValues[]
  name?: string
  scenarioId?: number
  partitionId?: number
}

export type FormattedBidWithIdAndTitle = {
  id: number
  title: string
} & FormattedBid

export type ScenarioPartitionResolution =
  | { mode: 'unpartitioned' }
  | { mode: 'partition-only'; partition: ElplanPartition }
  | { mode: 'subtype-bound'; partition: ElplanPartition; optjobSubtype: string }
  | {
      mode: 'error'
      reason:
        | 'partition-not-found'
        | 'binding-not-found'
        | 'duplicate-binding'
        | 'alias-key-collision'
        | 'invalid-partition-mode'
        | 'partition-mode-conflict'
    }

export type RenderableScenarioPartitionResolution = Exclude<ScenarioPartitionResolution, { mode: 'error' }>

export enum DayAheadTabId {
  PriceScenarios = 'day_ahead_price_scenarios',
  BidManagement = 'day_ahead_bid_management',
  Overview = 'day_ahead_overview',
  Plan = 'day_ahead_plan',
}

export type DayAheadTabDefinition = {
  id: DayAheadTabId
  title: string
  children: ReactElement[]
}
